var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBuscarrosa(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_2",
    "data-name": "Capa 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 300 55.72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #ff55b2;\n      }\n\n      .cls-2 {\n        letter-spacing: .2em;\n      }\n\n      .cls-3 {\n        letter-spacing: .2em;\n      }\n\n      .cls-4 {\n        font-family: MontserratRoman-Black, 'MontserratRoman Black';\n        font-size: 20px;\n        font-variation-settings: ';\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 300,
    height: 55.72
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-4",
    transform: "translate(106.91 35.41)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-3",
    x: 0,
    y: 0
  }, "BUS"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-2",
    x: 45.64,
    y: 0
  }, "C"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-3",
    x: 61.32,
    y: 0
  }, "AR")))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuscarrosa);
export default __webpack_public_path__ + "static/media/Buscar rosa.c362f9bc75f232f9148f631a4e257297.svg";
export { ForwardRef as ReactComponent };